import React, { useEffect } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import {
  navigationTab,
  navigationTabNotificationDot,
  navigationTabsList,
} from './NavigationTabs.css'
import { cssClass } from '@/shared/utils'

interface NavigationTabsProps {
  background?: string
  children: React.ReactNode
}

export const NavigationTabs: React.FC<NavigationTabsProps> = ({ 
  children, 
  background = 'bg-white-primary'
}) => {

  const styles = cssClass([navigationTabsList, background])

  return (
    <ul 
      className={styles}>
      {children}
    </ul>
  )
}

interface NavigationTabProps {
  children: React.ReactNode
  path?: string
  onClick?: () => void
  isActive?: boolean
}

export const NavigationTab = ({
  children,
  path,
  onClick,
  isActive,
}: NavigationTabProps) => {
  const { asPath } = useRouter()
  const active = isActive || path === asPath

  const ButtonAction = ({ children }) => {
    if (path) {
      return (
        <Link className="flex-1 text-center" href={path}>
          {children}
        </Link>
      )
    }

    return (
      <div className='flex-1 text-center' onClick={onClick}>
        {children}
      </div>
    )
  }

  return (
    <li className={navigationTab} data-is-active={active}>
      <ButtonAction>
        <span className="relative">{children}</span>
      </ButtonAction>
    </li>
  )
}

const NavigationTabNotificationDot = () => {
  return <span className={navigationTabNotificationDot} />
}

NavigationTab.NotificationDot = NavigationTabNotificationDot
